
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/store/shopping-bag",
      function () {
        return require("private-next-pages/[lang]/store/shopping-bag.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/store/shopping-bag"])
      });
    }
  